{
  "point": "puan",
  "points": "puan",
  "credits": "kredi",
  "loyaltyCredit": "Sadakat Kredisi",
  "statusPoints": "Durum Puanları",
  "balancePoints": "Harcanacak Puan",
  "edit": "Düzenle",
  "delete": "Sil",
  "copyOf": "{value} kopyası",
  "numberedCopyOf": "{value} için kopya {index}",
  "total": "toplam",
  "uplift": "artış",
  "approveBtn.label": "Tamam",
  "cancelBtn.label": "İptal",
  "createBtn.label": "Oluştur",
  "saveBtn.label": "Kaydet",
  "searchBtn.label": "Ara",
  "updateBtn.label": "Güncelle",
  "applyBtn.label": "Uygula",
  "addNewPlanBtn.label": "Plan Ekle",
  "launchPlanBtn.label": "Planı Başlat",
  "toOverviewBtn.label": "Genel Görünüme git",
  "collapseBtn.label": "Daralt",
  "extendBtn.label": "Ayrıntılar ",
  "updateAndSave.label": "Güncelle ve Kaydet",
  "pleaseConfirmBtn.label": "Onayla",
  "closeBtn.label": "Kapat",
  "resetBtn.label": "Sıfırla",
  "confirmBtn.label": "Onayla",
  "status.inactive": "Etkin Değil",
  "status.active": "Etkin",
  "status.deactivated": "Devre Dışı",
  "status.scheduled": "Programlanmış",
  "status.expired": "Sona Erdi",
  "status.readyToUse": "Kullanıma Hazır",
  "status.readyToLaunch": "Başlatmaya Hazır",
  "status.empty": "Boş",
  "status.activity.pending": "Beklemede",
  "status.activity.confirmed": "Onaylandı",
  "status.activity.expired": "Sona Erdi",
  "status.activity.canceled": "İptal Edildi",
  "status.activity.removed": "Kaldırıldı",
  "status.default": "Varsayılan",
  "action.promotion": "Promosyon",
  "action.referral": "Tavsiye",
  "action.action": "İşlem",
  "tiers.numberOfPurchases.plural.zero": "{number} alışveriş",
  "tiers.numberOfPurchases.plural.one": "{number} alışveriş",
  "tiers.numberOfPurchases.plural.two": "{number} alışveriş",
  "tiers.numberOfPurchases.plural.few": "{number} alışveriş",
  "tiers.numberOfPurchases.plural.many": "{number} alışveriş",
  "tiers.numberOfPurchases.plural.other": "{number} alışveriş",
  "validity.unlimited": "Sınırsız",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} gün",
  "validity.limitedFromEarn.value.days.plural.one": "{number} gün",
  "validity.limitedFromEarn.value.days.plural.two": "{number} gün",
  "validity.limitedFromEarn.value.days.plural.few": "{number} gün",
  "validity.limitedFromEarn.value.days.plural.many": "{number} gün",
  "validity.limitedFromEarn.value.days.plural.other": "{number} gün",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} hafta",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} hafta",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} hafta",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} hafta",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} hafta",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} hafta",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} ay",
  "validity.limitedFromEarn.value.months.plural.one": "{number} ay",
  "validity.limitedFromEarn.value.months.plural.two": "{number} ay",
  "validity.limitedFromEarn.value.months.plural.few": "{number} ay",
  "validity.limitedFromEarn.value.months.plural.many": "{number} ay",
  "validity.limitedFromEarn.value.months.plural.other": "{number} ay",
  "days": "Gün",
  "dayInMonth": "Gün",
  "month": "Ay",
  "months.1": "Ocak",
  "months.2": "Şubat",
  "months.3": "Mart",
  "months.4": "Nisan",
  "months.5": "Mayıs",
  "months.6": "Haziran",
  "months.7": "Temmuz",
  "months.8": "Ağustos",
  "months.9": "Eylül",
  "months.10": "Ekim",
  "months.11": "Kasım",
  "months.12": "Aralık",
  "form.missingSettingsAlert": "Kaydedip sonraki adıma devam etmeden önce gerekli tüm bilgileri girdiğinizden emin olun.",
  "noResults.title": "Sonuç bulunamadı.",
  "noResults.text": "\"{text}\" aramanız için eşleşen sonuç bulunmuyor.",
  "alertContainer.editModeAlert.message": "Sadakat planınızın sonraki versiyonunu düzenliyorsunuz. Değişiklikleriniz, bu yeni versiyonu başlatmanızın ardından geçerli olur. ",
  "alertContainer.liveModeAlert.message.linkText": "Daha Fazla Bilgi",
  "alertContainer.liveModeAlert.message": "Kademeleri, Sabit ve Ek Avantajları düzenlemek için, Sadakat Yönetimi'nden Güncelle ve Başlat'ı seçin, ardından Sonraki versiyonu düzenle'ye geçin. {link}",
  "card.isRoadmap.text": "Yol Haritası",
  "catalogSelector.tooManyResults.title": "Bu arama için çok fazla sonuç bulunuyor. ",
  "catalogSelector.tooManyResults.text": "Sonuçlarınızı daraltmak için daha belirgin anahtar kelimelerle tekrar arama yapmayı deneyin.",
  "catalogSelector.errorAlert": "Bir hata oluştu. Lütfen tekrar deneyin.",
  "catalogSelector.searchPlaceholder.byItem": "Belirli bir ürün arayın.",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "Promosyon sunmak istediğiniz belirli markaları veya kategorileri seçin.",
  "catalogSelector.checkAllItems.label": "Tümünü Seç",
  "catalogSelector.showAllSelections.label": "Yalnızca seçilen ögeleri göster.",
  "catalogSelector.cancelBtn.label": "Kapat",
  "catalogSelector.saveBtn.label": "Uygula ve Kaydet",
  "catalogSelector.brands.plural.zero": "{number} marka",
  "catalogSelector.brands.plural.one": "{number} marka",
  "catalogSelector.brands.plural.two": "{number} marka",
  "catalogSelector.brands.plural.few": "{number} marka",
  "catalogSelector.brands.plural.many": "{number} marka",
  "catalogSelector.brands.plural.other": "{number} marka",
  "catalogSelector.category.plural.zero": "{number} kategori",
  "catalogSelector.category.plural.one": "{number} kategori",
  "catalogSelector.category.plural.two": "{number} kategori",
  "catalogSelector.category.plural.few": "{number} kategori",
  "catalogSelector.category.plural.many": "{number} kategori",
  "catalogSelector.category.plural.other": "{number} kategori",
  "catalogSelector.product.plural.zero": "{number} ürün",
  "catalogSelector.product.plural.one": "{number} ürün",
  "catalogSelector.product.plural.two": "{number} ürün",
  "catalogSelector.product.plural.few": "{number} ürün",
  "catalogSelector.product.plural.many": "{number} ürün",
  "catalogSelector.product.plural.other": "{number} ürün",
  "confirmNavDialog.discardChanges.text": "Değişikliklerinizi kaydettiğinizden emin olun. Bu sayfadan ayrılırsanız kaydedilmeyen değişiklikler kaybolur.",
  "confirmNavDialog.approveBtn.label": "Tamam",
  "confirmNavDialog.cancelBtn.label": "İptal",
  "actionDashboard.overviewLinkText.referral": "Tavsiye İşlemlerine Git",
  "actionDashboard.editLinkText": "Programı Düzenle",
  "dashboardOptions.launchedAt": "Program başlatıldı: ",
  "dashboardOptions.currentlyShowingLabel": "An İtibarıyla Gösterilen:",
  "dashboardOptions.viewLabel": "Görüntüle:",
  "masterActions.join.largeText": "Sadakat Programına Katıl",
  "masterActions.purchases.largeText": "Alışveriş",
  "status.inactive.tooltip": "Ayarlar tamamlanmadı.",
  "status.inactive.tooltip.proomotionEnded": "Bu promosyon etkin değil ve düzenlenemez. Promosyonu kopyalayabilir veya yeni bir promosyon oluşturabilirsiniz.",
  "status.inactive.tooltip.connectedToRewardPools": "{name} kupon havuzu, {status} durumuna sahip.",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "Promosyon tarihlerini kontrol edin.",
  "status.readyToUse.tooltip.promotion": "Promosyon kullanıma hazır. Promosyonu üyenin Cüzdanında otomatik olarak görüntüleyebilir veya Sadakat belirteçlerini kullanarak Kampanya Düzenleyici'de üyelere ekleyebilirsiniz.",
  "status.readyToUse.tooltip.attachable": "İşlem kullanıma hazır ve sadakat belirteçleri kullanılarak kampanya düzenleyici aracılığıyla kişilere eklenebilir.",
  "status.active.tooltip.promotion": "Bu promosyon etkin ve üyeleriniz için kullanılabilir.",
  "status.active.tooltip.attachable": "Bu işlem etkin. Ayarları değiştiremezsiniz. Bu işlemi düzenlemek için öncelikle işlemi devre dışı bırakın ve belirtilen sona erme tarihini bekleyin. Ayrıca işlemi kopyalayabilir, düzenleyebilir ve yeni işlem olarak başlatabilirsiniz.",
  "status.active.tooltip.event": "Bu işlem etkin. İşlemi avantajlara veya otomasyon programına bağlayabilirsiniz.",
  "status.deactivated.tooltip.promotion": "Bu promosyonu devre dışı bıraktınız ve promosyon üyeleriniz için artık kullanılabilir değil.",
  "status.deactivated.tooltip.attachable": "Bu işlemi devre dışı bıraktınız. Bu işlemi düzenlemek veya silmek için belirtilen sona erme tarihini beklemeniz gerekir. Ayrıca işlemi kopyalayabilir, düzenleyebilir ve yeni işlem olarak başlatabilirsiniz.",
  "editorTypePopup.title": "Düzenleyici Türü Seç",
  "editorTypePopup.text": "Özel erişimi olmayan müşteriler bir blokaj sayfası görür. Özel bir HTML sayfası oluşturabilir veya şablonlarımızdan birini kullanabilirsiniz.",
  "editorTypePopup.options.html.text": "Özel HTML Sayfası Oluştur",
  "editorTypePopup.options.template.text": "Şablondan Sayfa Oluştur",
  "fileInputField.uploadBtn.label": "Yükle",
  "fileInputField.browseBtn.label": "Gözat",
  "formStepsContainer.nextStep.text": "Sonraki Adım",
  "formStepsContainer.prevStep.text": "Önceki Adım",
  "iconGallery.title": "Sadakat Simgesi Galerisi",
  "iconGallery.deleteDialog.headline": "Bu simgeyi silmek istediğinizden emin misiniz?",
  "iconGallery.deleteDialog.content": "Bu simgeyi sildikten sonra simge üyeler için görünür olmaz. Bu simgenin hiçbir işleme veya Kupona bağlı olmadığından emin olun.",
  "iconGallery.uploadResult.successMessage": "Yükleme başarılı.",
  "iconGallery.searchInput.placeholder": "Ada göre simge arayın.",
  "iconGallery.fileUploader.tooltip": "<h3>Yükle</h3><b>Simge yükleme gereklilikleri:</b></br>Dosya: SVG veya PNG</br>Biçim: Kare<br>Azami boyutlar: 200x200 piksel <br>Azami dosya boyutu: 100 KB</br><sub>* Saydam arka plan kullanılmasını öneririz </sub>.",
  "multiLangPopup.defaultNoticeText": "Uygun dil ayarları yoksa tanımladığınız birincil dil üyelerin gördüğü varsayılan dildir.",
  "multiLangPopup.defaultTitle.currency": "Para Birimi Çevirisi",
  "multiLangPopup.defaultTitle.language": "Dil Çevirisi",
  "multiMarketSelector.multiSelectField.placeholder": "-- Pazar seçin --",
  "multiMarketSelector.selectField.placeholder": "-- Pazar seçin --",
  "multiPlanSelect.label": "Sadakat Planınızı Seçin ",
  "preLaunchPopup.conditions.plan.title": "Plan Ayarları",
  "preLaunchPopup.conditions.plan.text": "Tüm ayarların doğru yapıldığından ve üye şartlarıyla eşleştiğinden emin olmak için Sadakat planı ayarlarınızı kontrol edin.",
  "preLaunchPopup.conditions.tiers.title": "Kademeler ve Avantajlar",
  "preLaunchPopup.conditions.tiers.text": "Kademelerinizin tüm üyeleriniz için doğru şekilde ayarlanıp ayarlanmadığını ve kademelerdeki kişi dağıtımınızın stratejinizle eşleşip eşleşmediğini kontrol edin.",
  "preLaunchPopup.conditions.rewards.title": "Ödül Havuzları",
  "preLaunchPopup.conditions.rewards.text": "Tüm yanıtlar için yeterli Kupon kodu yükleyip yüklemediğinizi ve tüm havuzların ve Kuponların geçerliliğinin doğru şekilde tanımlanıp tanımlanmadığını kontrol edin.",
  "preLaunchPopup.conditions.actions.title": "İşlemler",
  "preLaunchPopup.conditions.actions.text": "İşlemlerinizin kullanmak istediğiniz tüm taktikleri kapsayıp kapsamadığını ve varsayılan tüm işlemleri etkinleştirip etkinleştirmediğinizi kontrol edin.",
  "preLaunchPopup.title": "Sadakat planınızı başlatmak istediğinizden emin misiniz?",
  "preLaunchPopup.text": "Sadakat planınızın başlatmaya hazır olduğundan emin olmak için ayarlarınızı kontrol edin.",
  "timeValidityInput.radioLabel.days": "Gün",
  "timeValidityInput.radioLabel.weeks": "Hafta",
  "timeValidityInput.radioLabel.months": "Ay",
  "ctaUrl": "CTA URL",
  "ctaText": "CTA metni",
  "message": "Mesaj",
  "pageNotFound": "Aradığınız sayfayı bulamıyoruz.",
  "externalEventSetup.title": "Harici Sadakat Etkinliği",
  "externalEventSetup.name.label": "Harici Etkinlik Adı",
  "externalEventSetup.description.label": "Tanım",
  "externalEventSetup.description.tooltip": "Tanım dahilidir ve Sadakat etkinliklerinizi yönetmenize yardımcı olur.",
  "pointsRatesFields.perDescriptor.points": "şuna göre kazanılan:",
  "catalog.item.type.category.name": "Kategori",
  "catalog.item.type.brand.name": "Marka",
  "catalog.item.type.item.name": "Ürün",
  "catalog.item.type.itemId.name": "Öge Kimliği",
  "exclusiveAccessOffers.options.fixedBenefit.title": "Sabit Avantaj Olarak Erişim",
  "exclusiveAccessOffers.options.additionalBenefits.title": "Ek Avantaj Olarak Erişim",
  "exclusiveAccessOffers.options.action.title": "İşlem Ödülü Olarak Erişim",
  "exclusiveAccessOffers.options.redemption.title": "Puanlar İçin Erişim",
  "exclusiveAccessOffers.options.redemptionForFree.title": "Ücretsiz Erişim",
  "accessValidityType.options.unlimited.name": "Erişim, sınırsız bir zaman aralığı boyunca geçerlidir.",
  "accessValidityType.options.limitedFromEarn.name": "Erişim, üye kazandığında başlayan sınırsız bir zaman aralığı boyunca geçerlidir.",
  "accessValidityType.options.fixedDate.name": "Erişim, tüm üyeler için önceden tanımlanan bir zaman aralığı boyunca geçerlidir.",
  "accessValidityType.options.disabled.fixedBenefit.name": "Sabit avantaj olarak erişim kullanılabilirliğini devre dışı bırakın.",
  "accessValidityType.options.disabled.additionalBenefit.name": "Ek avantaj olarak erişim kullanılabilirliğini devre dışı bırakın.",
  "accessValidityType.options.disabled.reward.name": "İşlem ödülü olarak erişim kullanılabilirliğini devre dışı bırakın.",
  "createOfModify.options.create.name": "Teklifi Etkinleştir",
  "createOfModify.options.create.tooltip": "Yeni bir teklifi etkinleştirdiğinizde etkin teklif kuralları sıfırlanır ve tanımlanan teklif zaman aralığı boyunca seçilen tüm kademelerdeki üyeler için kullanılabilir olur.",
  "createOfModify.options.create.tooltip2": "Yeni bir teklifi etkinleştirdiğinizde etkin teklif kısıtlamaları sıfırlanır ve tanımlanan teklif zaman aralığı boyunca seçilen tüm kademelerdeki üyeler için kullanılabilir olur. ",
  "createOfModify.options.modify.name": "Etkin Teklifi Düzenle",
  "createOfModify.options.modify.tooltip": "Etkin bir teklifi düzenlediğinizde değişiklikleriniz, bu teklifi zaten kullanan üyeleri etkilemez.",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "Özel Kullanım Ayarları",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "Blokaj Sayfası",
  "exclusiveAccessFormSteps.redemptionValue.title": "Erişim ve Teklifler",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "Etkinleştirme",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "harcanacak {{points_name}}",
  "activityElementPointsText.status": "Durum {{points_name}}",
  "activityElementPointsText.cashback": "Para İadesi",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "Tek Kullanımlık Kupon",
  "voucherTypeText.yearly": "Çok Kullanımlık Kupon",
  "exclusiveAccessTypeText.permanent": "Sürekli Özel Erişim",
  "exclusiveAccessTypeText.limitedTerm": "Sınırlı Süreli Özel Erişim",
  "mainTabs.dashboard.title": "Yönetim Konsolu",
  "mainTabs.actions.title": "İşlemler",
  "mainTabs.rewards.title": "Ödüller",
  "mainTabs.tiers.title": "Kademeler",
  "mainTabs.loyaltyWallet.title": "Sadakat Cüzdanı",
  "mainTabs.memberProfiles.title": "Üye Profilleri",
  "mainTabs.externalEvents.title": "Harici Etkinlikler",
  "mainTabs.planSettings.title": "Plan Ayarları",
  "mainTabs.vouchers.title": "Kuponlar",
  "mainTabs.exclusiveAccesss.title": "Özel Erişim",
  "mainTabs.loyaltyManagement.title": "Sadakat Yönetimi",
  "mainTabs.security.title": "Sadakat Yapılandırmaları",
  "actionTabs.purchases.title": "Alışverişler",
  "actionTabs.promotions.title": "Promosyonlar",
  "actionTabs.engagements.title": "Etkileşim",
  "actionTabs.events.title": "Etkinlikler",
  "actionTabs.referral.title": "Tavsiye",
  "actionTabs.join.title": "Sadakat Programına Katıl",
  "tierTabs.tiers.title": "Kademeler",
  "tierTabs.fixedBenefits.title": "Sabit Avantajlar",
  "tierTabs.additionalBenefits.title": "Ek Avantajlar",
  "tierTabs.contactDistribution.title": "Dağıtım Grafiği",
  "managementTabs.accountSettings.title": "Hesap Ayarları",
  "managementTabs.languageAndCurrency.title": "Dil ve Para Birimi",
  "managementTabs.planSettings.title": "Plan Ayarları",
  "managementTabs.cashbackSettings.title": "Para İadesi Ayarları",
  "managementTabs.membershipSettings.title": "Üyelik Ayarları",
  "managementTabs.updateAndLaunch.title": "Güncelle ve Başlat",
  "onboardingTabs.accountSettings.title": "Plan Oluşturma",
  "onboardingTabs.activation.title": "Etkinleştirme",
  "customerCalcPeriod.options.1.name": "Son 30 gün",
  "customerCalcPeriod.options.2.name": "Son 60 gün",
  "customerCalcPeriod.options.3.name": "Son 90 gün",
  "customerCalcPeriod.options.6.name": "Son 6 Ay",
  "customerCalcPeriod.options.12.name": "Son 12 Ay",
  "planType.options.points.name": "Puanlar ve Kullanma",
  "planType.options.points_and_benefits.name": "Puanlar ve Avantajlar",
  "planType.options.spend.name": "Harcama ve Avantajlar",
  "planType.options.points.tooltip": "Tekli veya çoklu kademe ve puan kullanımı olan puan temelli plan.",
  "planType.options.points_and_benefits.tooltip": "Puan kullanımı olmadan çoklu kademe ve avantajı olan puan temelli plan.",
  "planType.options.spend.tooltip": "Puanları olmayan ancak para iadesi seçeneği kuralları olan, tekli veya çoklu kademesi ve avantajı olan harcama temelli plan. Harcama temelli planda yalnızca bir para birimi yönetilir. Birden fazla para birimi yönetirseniz her bir para birimi için ayrı plan yönetmeniz gerekir.",
  "pointsAllocatopmDelay.options.1.name": "24 Saat",
  "pointsAllocatopmDelay.options.2.name": "48 Saat",
  "pointsAllocatopmDelay.options.3.name": "72 Saat",
  "pointsAllocatopmDelay.options.7.name": "7 Gün",
  "pointsAllocatopmDelay.options.14.name": "14 Gün",
  "pointsAllocatopmDelay.options.21.name": "21 Gün",
  "pointsAllocatopmDelay.options.30.name": "30 Gün",
  "pointsAllocatopmDelay.options.40.name": "40 Gün",
  "tierCalculationType.options.endOfYear.name": " Kademe hesaplama her [X yıl] içinde bir kez 31 Aralık tarihinde gerçekleşir.",
  "tierCalculationType.options.endOfYear.tooltip": "Kademeler, her [x yıl] içinde bir kez sabit bir tarihte hesaplanır. Daha yüksek bir kademeye yükseltilen üyeler kademe durumlarını tanımlanan dönem boyunca korur.",
  "tierCalculationType.options.afterJoin.name": "Kademe hesaplama, üyenin bir kademeye girdiği tarihten itibaren [X ay] için yapılır.",
  "tierCalculationType.options.afterJoin.tooltip": "Kademe hesaplama tarihi, üyenin kademeler boyunca ilerleme durumuna bağlı olarak değişebilir. Daha yüksek bir kademeye yükseltilen üyeler kademe durumlarını en azından tanımlanan dönem boyunca korur.",
  "tierCalculationType.options.endOfYear.spend.tooltip": "Kademe hesaplandığında Sadakat kredisi sıfırlanır ancak üyeler kademe durumlarını sonraki hesaplamaya kadar korur.",
  "tierCalculationType.options.noDropout.name": "Kademeler hesaplanmaz. Üyelerin bu kademede kalmak için gereklilikleri karşılaması gerekmez.",
  "tierCalculationType.options.noDropout.tooltip": "Puanlar yalnızca kademeleri yükseltme amacıyla toplanır.",
  "statusPointsExpirationType.options.tierCalc.name": "Durum puanlarının süresi kademe hesaplama tarihinde sona erer ve puanlar sıfırlanır.",
  "statusPointsExpirationType.options.tierCalc.tooltip": "Puanlar hesaplandığında sıfırlanır ancak üyeler kademe durumlarını sonraki hesaplamaya kadar korur.",
  "statusPointsExpirationType.options.fromEarn.name": "Durum puanlarının süresi, üyenin puan kazandığı tarihten sonraki her [X ay] içinde sona erer ve puanlar sıfırlanır.",
  "statusPointsExpirationType.options.fromEarn.tooltip": "Kademeler hesaplandığında yalnızca söz konusu gün için geçerli puanlar hesaplanır. Üyeler durumlarını korur veya daha düşük bir kademeye düşer.",
  "statusPointsExpirationType.options.never.name": "Durum puanlarının süresi asla sona ermez.",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "Kademelerin hesaplandığı tarihte sadakat kredisinin süresi sona erer ve kredi sıfırlanır.",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "Sadakat kredisi hesaplandığında sıfırlanır ancak üyeler kademe durumlarını sonraki hesaplamaya kadar korur.",
  "loyaltyCreditExpirationType.options.fromEarn.name": "Üyenin kredi kazandığı tarihten sonraki her [X ay] içinde Sadakat kredisinin süresi sona erer ve kredi sıfırlanır.",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "Kademeler hesaplandığında yalnızca söz konusu gün için geçerli Sadakat kredisi hesaplanır. Üyeler durumlarını korur veya daha düşük bir kademeye düşer.",
  "optIn.options.invitation.name": "Tüm kişiler Sadakat planına katılmaya davet edilir.",
  "optIn.options.automatic.name": "Tüm kişiler otomatik olarak Sadakat üyesi haline gelir.",
  "historicalBalancePoints.options.keep.name": "Harcama Puanları ile ödüllendirin.",
  "historicalBalancePoints.options.keep.tooltip": "Bu seçenek, üyeleri ödül puanlarını kullanmaları için teşvik eder.",
  "historicalBalancePoints.options.remove.name": "Harcama Puanları ile ödüllendirmeyin.",
  "historicalBalancePoints.options.remove.tooltip": "Harcama Puanları sıfırlanır ve üyelerin kullanmak için yeni puan kazanması gerekir.",
  "currencyIdentifierSigh.options.symbol.name": "Para Birimi Sembolü",
  "currencyIdentifierSigh.options.symbol.tooltip": "Örnek: 500 $",
  "currencyIdentifierSigh.options.code.name": "ISO Para Birimi Kodu",
  "currencyIdentifierSigh.options.code.tooltip": "Örnek: 500 ABD Doları",
  "currencyIdentifierSigh.options.none.name": "Tanıtıcı Olmadan",
  "formStepRewards.options.poolSettings.title": "Havuz Ayarları",
  "formStepRewards.options.uploadFile.title": "Dosya Yükle",
  "formStepRewards.options.redemptionValue.title": "Teklif Ayarları",
  "formStepRewards.options.validity.title": "Geçerlilik",
  "specialTiers.redemptopmSettings.all.name": "Tüm kademeler için aynı ayarları kullanın. Münferit kademe değerleri geçersiz kılınır.",
  "voucherValidityType.options.unlimited.name": "Kupon, sınırsız bir zaman aralığı boyunca geçerlidir.",
  "voucherValidityType.options.limitedFromEarn.name": "Kupon, üyenin Kuponu kazandığı zamandan itibaren sınırsız bir zaman aralığı boyunca geçerlidir.",
  "voucherValidityType.options.fixedDate.name": "Kupon, tüm üyeler için önceden tanımlanan bir zaman aralığı boyunca geçerlidir.",
  "redemptionLimit.options.noLimit.name": "Bu teklifi üyelere düzenli aralıklarla otomatik olarak gösterin.",
  "redemptionLimit.options.noLimit.tooltip": "Bir kademe için değiştirmeyi etkinleştirirseniz kullanım teklifi, kullanım kısıtlaması olmadan Sadakat Cüzdanı'nda gösterilir.",
  "redemptionLimit.options.limitMember.name": "Her bir üyenin, bu teklif için tanımlanan zaman aralığı boyunca bir Kuponu kaç kez kullanabileceğini seçin.",
  "exclusiveAccessExclusivityType.options.name.fixed": "Sürekli Özel Kullanım",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "Sınırlı Süreli Özel Kullanım",
  "exclusiveAccessExclusivityType.options.name.limited": "Sınırlı Özel Kullanım",
  "editorContentTextDefaultValues.tag": "Özel Erişim",
  "editorContentTextDefaultValues.firstHeader": "<strong>Erken Black Friday</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>İNDİRİM</strong>",
  "editorContentTextDefaultValues.middleText": "Sadık üyelerimiz için özel Black Friday teklifleri. Kaçırmayın. Sadakat planına hemen katılın!",
  "editorContentTextDefaultValues.actionTopText": "Henüz üye değil misiniz? Sadakat planımıza katılın ve ödül kazanmaya başlayın.",
  "editorContentTextDefaultValues.leftButton": "Sadakat Programına Katıl",
  "editorContentTextDefaultValues.rightButton": "Başka Bir Zaman",
  "editorContentTextDefaultValues.actionBottomText": "<span>Zaten üye misiniz? <u>Oturum açın</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "Sadık üyelerimiz için özel teklifler. Kaçırmayın. Sadakat planımıza hemen katılın!",
  "editorContentTextDefaultValues.actionTopText.mobile": "Henüz üye değil misiniz? Sadakat programımıza katılın.",
  "accessUrlType.options.exactUrl.name": "Şu sayfayı bloke edin ve sayfaya özel erişim sunun:",
  "accessUrlType.options.startsWithUrl.name": "Şu URL ile başlayan tüm sayfaları bloke edin ve sayfalara özel erişim sunun:",
  "formStepsContainer.tierSettings.title": "Kademe Ayarları",
  "formStepsContainer.purchaseBenefits.title": "Alışveriş Avantajları",
  "formStepsContainer.visibility.title": "Görünürlük",
  "tierDropout.options.yes.name": "Evet, bu kademe hesaplanır ve üyelerin bu kademede kalmak için gereklilikleri karşılaması gerekir.",
  "tierDropout.options.no.name": "Hayır, bu kademede düşme senaryosu yoktur.",
  "fixedBenfitType.options.oneTimeVoucher.name": "Bir Defalık Kupon",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "Sabit Yıllık Kupon (çok kullanımlık kupon gereklidir)",
  "fixedBenfitType.options.eventAction.name": "Etkinlik",
  "fixedBenfitType.options.exclusiveAccess.name": "Özel Erişim",
  "fixedBenfitType.options.custom.name": "Özel (sizin tarafınızdan bağımsız olarak sağlanır)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "Çok Kullanımlık Kupon (çok kullanımlık kod gereklidir)",
  "tierTypeOptions.regular.name": "Puan Temelli",
  "tierTypeOptions.invite.name": "Yalnızca Davet",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "Daha fazla bilgi",
  "tierTypeOptions.invite.tooltip": "Yalnızca davet edilen veya ödeme yapan üyeler kademeye ait olabilir. Ödemeyi ve üyeliği kendi tarafınızda yönetin. Bu kademeye üye eklemek için Sadakat API'sini veya Üye Profilleri'ni kullanın. {learnMoreLink}.",
  "tierTypeOptions.spend.name": "Harcama Temelli",
  "exclusiveAccess.cardLabels.permanent": "Sürekli",
  "exclusiveAccess.cardLabels.limtedTerm": "Sınırlı Süreli",
  "cards.filterBar.moreFiltersButton": "Daha Fazla Filtre",
  "catalogSelector.selected.single": "{items} seçildi",
  "catalogSelector.selected.multiple": "{items} ve {lastItems} seçildi",
  "iconGallery.uploadResult.failMessage": "Yükleme sırasında bir sorun oluştu. Dosyaların gereksinimleri karşıladığından emin olun. \n{showFileList,select,true{{failed}/{total} başarısız: {failedDetails}} diğer{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "her",
  "activityElementMultiuplyPointsText.double": "Çift",
  "activityElementMultiuplyPointsText.triple": "Üçlü"
}
